export const TRANSLATES = {
    ru: {
        'BLOWS': 'Удары',
        'BLOWS_2': 'Удары в створ',
        'GOALS': 'Голы',
        'PERCENTS_ACCURATE_PASS': 'Точные передачи',
        'PERCENTS_NO_ACCURATE_PASS': 'Неточные передачи',
        'EFFECTIVE_STROKES': 'Эффективные обводки',
        'GOALS_PASS': 'Голевые передачи',
        'SELECTIONS': 'Отборы',
        'LOSSES': 'Потери',
        'SAVES': 'Сейвы',
        'MISSED_BALLS': 'Пропущенные мячи',

        'EVENTS': 'События',
        'FIELD_PLAYER': 'Полевой',
        'GOALKEEPER': 'Вратарь',
        'TIME_LEFT': 'Прошло времени',
        'START': 'Старт',
        'STOP': 'Стоп',
        'DATE_MATCH': 'Дата матча',
        'NO_DATA': 'Нет данных',
        'REMOVE': 'Удалить',
        'REMOVE_PLAYER': 'Убрать игрока',

        'FOOTER_TEXT': 'Umbrella Group LLC Delaware, USA All rights reserved.',
        'BTN_MATCH_START_TEXT': 'Старт матча',
        'BTN_MATCH_FINISH_TEXT': 'Завершить матч',
        'BTN_MATCH_CONTINUE_TEXT': 'Продолжить матч',
        'BTN_MATCH_STOP_TEXT': 'Приостановить матч',
        'FORM_ADD_PLAYER_NAME_LABEL': 'ФИО',
        'FORM_ADD_PLAYER_NUMBER_TEXT': 'Номер',
        'FORM_ADD_PLAYER_ROLE_TEXT': 'Роль',
        'FORM_ADD_PLAYER_SUBMIT_TEXT': 'Добавить игрока',
        'BTN_MATCH_CSV_TEXT': 'Загрузка CSV',

        'ADD_PLAYER_ERROR': 'Игрок с таким именем или номером уже добавлен',

        'GRID_COL_NUMBER': 'Номер',
        'GRID_COL_NAME': 'Имя',
        'GRID_COL_TYPE': 'Роль',
        'GRID_COL_RANK': 'Ранг',
        'GRID_COL_KPI': 'КПИ',
        'GRID_COL_TIMER': 'Таймер',
        'GRID_COL_IN_GAME': 'Время в игре',

        'FORM_CREATE_MATCH_NAME_LABEL': 'Название матча',
        'STOP_MODAL_TEXT': 'Основное время истекло',
        'ADD_PLAYER_TOOLTIP': 'Для старта матча добавьте от 4 до 14 игроков'
    }
}